// What the reseller's pricing actions say when the API refuses (prices, on/off, order: hoisted on
// real reuse). tld_unpriced reads differently when switching on, so the switch says it itself.
import { ApiError } from "@/lib/api-client";
import { m } from "@/lib/paraglide/messages.js";

const MESSAGES: Partial<Record<string, () => string>> = {
  forbidden: m.reseller_pricing_forbidden,
  feature_read_only: m.reseller_pricing_read_only,
  price_below_wholesale: m.reseller_pricing_below,
  tld_unpriced: m.reseller_pricing_keep_register,
  term_not_offered: m.reseller_pricing_stale,
  not_found: m.reseller_pricing_stale,
};

/** The message for a failed pricing change; null when there is no error. */
export function pricingError(error: unknown): string | null {
  if (!error) return null;
  const code = error instanceof ApiError ? error.code : "internal";
  return (MESSAGES[code] ?? m.tld_pricing_failed)();
}
